/**
 * API service for the Shift Roster page
 */
import { store } from '../../../store';
import { apiRequest } from '../../../services/apiMiddleware';
import { API_GATEWAY_PROCESS_NAME } from '../../../utils/constants';
import { GetShiftRosterRequest, GetShiftRosterResponse } from './models';
import { showError } from '../../../store/slices/errorSlice';

const EMPTY_RESPONSE: GetShiftRosterResponse = {
  employees: [],
  totalCount: 0,
  pageNumber: 0,
  totalPages: 0,
  limit: 0,
};

export const getShiftRoster = async (
  warehouseId: string,
  planId: string,
  pageNumber: number,
  limit: number,
): Promise<GetShiftRosterResponse> => {
  try {
    if (!warehouseId) {
      store.dispatch(showError({
        title: 'Warehouse ID Required',
        message: 'Please select a valid warehouse ID from the dropdown',
      }));
      return EMPTY_RESPONSE;
    }

    const requestBody: GetShiftRosterRequest = {
      warehouseId,
      planId,
      pageNumber,
      limit,
    };

    const requestPayload = {
      resourcePath: '/getShiftRoster',
      httpMethod: 'post',
      processName: API_GATEWAY_PROCESS_NAME,
      requestBody,
    };

    const response = await apiRequest(requestPayload);

    if (response.status && response.status >= 400) {
      store.dispatch(showError({
        title: 'Failed to fetch shift roster data',
        message: response.errorResponse || 'Unable to fetch shift roster data. Please try again later.',
      }));
      return EMPTY_RESPONSE;
    }

    return response.data;
  } catch (error: any) {
    console.error('Error fetching shift roster data:', error);
    store.dispatch(showError({
      title: 'Failed to fetch shift roster data',
      message: error.errorResponse || error.message || 'Unable to fetch shift roster data. Please try again later.',
    }));
    return EMPTY_RESPONSE;
  }
};
